/**
 *  @class
 *  @function MiluviaStats
 */
(function() {
  'use strict';

  function initStatsSection(section) {
    if (section.dataset.initialized === 'true') return;
    
    const numbers = section.querySelectorAll('.miluvia-stats__number');
    if (numbers.length === 0) return;
    
    section.dataset.initialized = 'true';
    
    // Use Intersection Observer to trigger animation when section is visible
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateNumbers(numbers);
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.3
    });
    
    observer.observe(section);
  }

  function animateNumbers(numbers) {
    numbers.forEach((numberEl, index) => {
      const targetValue = parseFloat(numberEl.dataset.target) || 0;
      const valueEl = numberEl.querySelector('.miluvia-stats__number-value');
      
      if (!valueEl || isNaN(targetValue)) return;

      // Stagger animation start times
      setTimeout(() => {
        animateNumber(valueEl, 0, targetValue, 2000);
      }, index * 150);
    });
  }

  function animateNumber(element, start, end, duration) {
    const startTime = performance.now();
    const isDecimal = end % 1 !== 0;
    
    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      
      const current = start + (end - start) * easeOut;
      
      if (isDecimal) {
        element.textContent = current.toFixed(1);
      } else {
        element.textContent = Math.floor(current);
      }
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Ensure final value is exact
        if (isDecimal) {
          element.textContent = end.toFixed(1);
        } else {
          element.textContent = Math.floor(end);
        }
      }
    };
    
    requestAnimationFrame(animate);
  }

  // Initialize on page load
  function initAllSections() {
    const statsSections = document.querySelectorAll('.miluvia-stats');
    statsSections.forEach(section => {
      initStatsSection(section);
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  // Handle Shopify theme editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.miluvia-stats');
      if (section) {
        initStatsSection(section);
      }
    });
  }
})();
